import React from 'react'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import { Image } from 'react-components/atoms'
import { CAS_DOMAIN } from 'utils'
import Chip from 'components/atomic/Chip'
import { Button } from 'react-components/atoms'
import {
  NumeroRivistaCard,
  BoxContenutiNumeroRivista,
  BoxAbbonamento,
} from 'react-components/molecules'
import { BoxElementiRivista } from 'react-components/organisms'
import { useTrans } from 'hooks'
import { useEffect } from 'react'
import { sendProductImpressionGTM } from '../../../utils/gtm'
import BannerInserto from 'react-components/molecules/BannerInserto/BannerInserto'
import { useRouter } from 'next/router'
import { ArrowRightLong } from 'react-components/atoms/Icons'

const NumeroRivistaTemplate = (props) => {
  const {
    numeroRivista,
    numeri = [],
    tassonomie = [],
    articoli = [],
    lezioni = [],
    boxAbbonamento = [],
    page,
    className = '',
  } = props

  useEffect(() => {
    if (numeri) {
      sendProductImpressionGTM(numeri, 'archivio_carosello')
    }
  }, [numeri])
  const t = useTrans()
  const router = useRouter()

  return (
    <main className={`numero-rivista-template ${className ? ` ${className}` : ''}`}>
      <div className="w-container">
        <Breadcrumbs breadcrumbs={page.breadcrumbs} />
        <div className="numero-rivista-template__container">
          <div className="numero-rivista-template__image numero-rivista-template__image--desktop">
            <Image
              src={CAS_DOMAIN + numeroRivista.main_image}
              alt={numeroRivista.titolo?.toAltTitle()}
              title={numeroRivista.titolo?.toAltTitle()}
              width={415}
              height={565}
              priority={true}
            />
            {numeroRivista.rivista.slug && numeroRivista.rivista.slug == 'psicologia-e-scuola' ? (
              <div className="numero-rivista-template__inserto--desktop">
                <BannerInserto
                  title={t('BannerInsertoNumeroPsicologiaEScuolaTitle')}
                  text={t('BannerInsertoNumeroPsicologiaEScuolaText')}
                  pdpVersion={true}
                />
              </div>
            ) : (
              <></>
            )}
            {numeroRivista.rivista.slug &&
            numeroRivista.rivista.slug == 'vita-scolastica' &&
            numeroRivista.inserto_link ? (
              <div className="numero-rivista-template__inserto--desktop">
                <BannerInserto
                  title={t('BannerInsertoNumeroVitaScolasticaTitle')}
                  pdpVitaScolastica={true}
                  buttonClickFunction={() => {
                    router.push(`../${numeroRivista.inserto_link}`)
                  }}
                  imageSrc={CAS_DOMAIN + numeroRivista.rivista?.inserto?.rivista?.main_image}
                  width={90}
                  height={31}
                  icon={<ArrowRightLong />}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="numero-rivista-template__content">
            <p className="numero-rivista-template__rivista">{t('NUMERO IN CORSO')}</p>
            <h1 className="numero-rivista-template__title">{numeroRivista.titolo}</h1>
            <div className="numero-rivista-template__image numero-rivista-template__image--mobile">
              <Image
                src={CAS_DOMAIN + numeroRivista.main_image}
                alt={numeroRivista.titolo?.toAltTitle()}
                title={numeroRivista.titolo?.toAltTitle()}
                width={125}
                height={170}
                priority={true}
              />
            </div>
            <p className="numero-rivista-template__description numero-rivista-template__description--desktop">
              {numeroRivista.descrizione}
            </p>
            {numeroRivista.link_esterno ? (
              <>
                <Button
                  label={t('Leggi lo sfogliabile')}
                  href={numeroRivista.link_esterno}
                  variant="secondary"
                  className="numero-rivista-template__cta-sfogliabile"
                  newPage
                  external
                />
              </>
            ) : (
              <>
                <div className="numero-rivista-template__abbonati-top">
                  <span className="numero-rivista-template__abbonati-top__label">
                    {t('Vuoi l’accesso alla versione digitale?')}
                  </span>
                  <Button
                    label={t('Abbonati')}
                    href="#come-abbonarsi"
                    variant="primary"
                    className="numero-rivista-template__abbonati-top__cta"
                  />
                </div>
              </>
            )}
            <p className="numero-rivista-template__description numero-rivista-template__description--mobile">
              {numeroRivista.descrizione}
            </p>
            {articoli.length > 0 && (
              <BoxContenutiNumeroRivista
                className="numero-rivista-template__articoli"
                contenuti={articoli}
                titolo={t('Articoli sul tema del mese')}
              />
            )}
            {numeroRivista.rivista.slug && numeroRivista.rivista.slug == 'psicologia-e-scuola' ? (
              <div className="numero-rivista-template__inserto--mobile">
                <BannerInserto
                  title={t('BannerInsertoNumeroPsicologiaEScuolaTitle')}
                  text={t('BannerInsertoNumeroPsicologiaEScuolaText')}
                  pdpVersion={true}
                />
              </div>
            ) : (
              <></>
            )}
            {numeroRivista.rivista.slug &&
            numeroRivista.rivista.slug == 'vita-scolastica' &&
            numeroRivista.inserto_link ? (
              <div className="numero-rivista-template__inserto--mobile">
                <BannerInserto
                  title={t('BannerInsertoNumeroVitaScolasticaTitle')}
                  pdpVitaScolastica={true}
                  buttonClickFunction={() => {
                    router.push(`../${numeroRivista.inserto_link}`)
                  }}
                  imageSrc={CAS_DOMAIN + numeroRivista.rivista?.inserto?.rivista?.main_image}
                  width={90}
                  height={31}
                  icon={<ArrowRightLong />}
                />
              </div>
            ) : (
              <></>
            )}
            {lezioni.length > 0 && (
              <BoxContenutiNumeroRivista
                className="numero-rivista-template__lezioni"
                contenuti={lezioni}
                titolo={t('In evidenza')}
              />
            )}
            {tassonomie.length > 0 && (
              <div className="numero-rivista-template__tassonomie">
                <p className="numero-rivista-template__tassonomie__title">
                  {t('Lezioni e materiali di questo numero')}
                </p>
                <div className="numero-rivista-template__tassonomie__items">
                  {tassonomie.slice(0, 12).map((item) => (
                    <Chip
                      className="numero-rivista-template__tassonomie__item"
                      label={item.nome}
                      href={`${numeroRivista.url}risorse?filtri_id=${item.id}`}
                      close={false}
                    />
                  ))}
                </div>
                <Button
                  label={t('Vedi tutti')}
                  href={`${numeroRivista.url}risorse`}
                  variant="secondary"
                  className="numero-rivista-template__tassonomie__cta"
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="numero-rivista-template__bottom">
        {numeri.length > 1 && (
          <div id="archivio" className="numero-rivista-template__archivio">
            <BoxElementiRivista
              elementi={numeri.map((numero, index) => (
                <NumeroRivistaCard
                  numero={numero}
                  key={index}
                  position={index + 1}
                  parentList={'archivio_carosello'}
                />
              ))}
              titolo={t('Archivio')}
              ctaLabel={t('Vedi tutti i numeri')}
              ctaLink={`${numeroRivista.rivista.url}archivio`}
            />
          </div>
        )}
        {boxAbbonamento.length > 0 && (
          <div id="come-abbonarsi" className="numero-rivista-template__abbonamenti">
            <p className="numero-rivista-template__abbonati">
              {t('Abbonati a "{0}"', [numeroRivista.rivista.titolo])}
            </p>
            <div className="numero-rivista-template__box-abbonamenti">
              {boxAbbonamento.map((box, index) => (
                <BoxAbbonamento
                  box={box}
                  className="numero-rivista-template__box-abbonamenti__item"
                  key={index}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </main>
  )
}

export default NumeroRivistaTemplate
